import { useEffect, useState } from "react";
import { Box, Text, Loader, Stack } from "@mantine/core";
import { versionApi, BuildInfo } from "../../api";
import classes from "./VersionInfo.module.css";
import { t } from "i18next";

export function VersionInfo() {
    const [buildInfo, setBuildInfo] = useState<BuildInfo | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchVersionInfo = async () => {
            try {
                setLoading(true);
                const info = await versionApi();
                setBuildInfo(info);
                setError(null);
            } catch (err) {
                setError(t("versionInfo.loadingError"));
            } finally {
                setLoading(false);
            }
        };

        fetchVersionInfo();
    }, []);

    if (loading) {
        return (
            <Box p="sm" className={classes.versionContainer}>
                <Loader size="xs" />
            </Box>
        );
    }

    if (error) {
        return (
            <Box p="sm" className={classes.versionContainer}>
                <Text size="xs" c="dimmed">
                    {error}
                </Text>
            </Box>
        );
    }

    if (!buildInfo) {
        return null;
    }

    return (
        <Box p="sm" className={classes.versionContainer}>
            <Stack gap="xs">
                <Text size="xs" fw={500}>
                    {t("versionInfo.title")}
                </Text>
                <Stack gap={2}>
                    <Text size="xs">
                        <strong>{t("versionInfo.gitHash")}:</strong> {buildInfo.gitHash.slice(0, 8)}
                    </Text>
                    <Text size="xs">
                        <strong>{t("versionInfo.buildTime")}:</strong> {new Date(buildInfo.buildTime).toLocaleDateString()}
                    </Text>
                </Stack>
            </Stack>
        </Box>
    );
}
